import dayjs from 'dayjs';

import { programDetail, schduleList } from '@/network/apis/apiUri';

const postData = (type, add = 0) => ({
  address: 'https://script.arirang.com/api/v1/bis/listScheduleV3.do',
  method: 'POST',
  headers: {},
  body: {
    data: {
      dmParam: {
        chanId: type === 'world' ? 'CH_W' : type === 'korea' ? 'CH_K' : type === 'un' ? 'CH_Z' : 'CH_R',
        broadYmd: dayjs.tz().add(add, 'day').format('YYYYMMDD'),
        planNo: '1',
      },
    },
  },
});

/***
 * radio = CH_R
 * UN  = CH_Z
 * korea = CH_K
 */

const transLocaleTime = (type, broadYmd, broadHm) => {
  if (type === 'world') return dayjs.tz(broadYmd.concat(broadHm)).utc().format('HH:mm');
  if (type === 'korea') return dayjs(broadYmd.concat(broadHm)).format('HH:mm');
  if (type === 'un') return dayjs(broadYmd.concat(broadHm)).tz('America/New_York').format('HH:mm');
  return dayjs.tz(broadYmd.concat(broadHm)).format('HH:mm');
};

const programEndTime = (broadYmd, broadHm, broadRun) => {
  const hour = Math.floor(broadRun / 60) * 100;
  const min = broadRun % 60;

  return +broadYmd.concat(broadHm) + hour + min;
};

export const db = {
  now: dayjs.tz().format('YYYYMMDDHHmm'),

  async get(type, mode) {
    let data = [];

    const curResponse = await schduleList(postData(type));
    const curData = curResponse.data.responseBody.dsSchWeek
      .filter((item) => programEndTime(item.broadYmd, item.broadHm, item.broadRun) > +this.now)
      .slice(0, 2)
      .map((item) => ({
        id: item.pgmCd,
        title: type === 'radio' ? item.displayNm : item.pgmOnm,
        isFirst: type !== 'radio' && item.firstClf === '01',
        broadTime: transLocaleTime(type, item.broadYmd, item.broadHm),
      }));

    data.push(...curData);

    if (curData.length < 2) {
      const nextResponse = await schduleList(postData(type, 1));
      const nextData = nextResponse.data.responseBody.dsSchWeek
        .filter((item) => programEndTime(item.broadYmd, item.broadHm, item.broadRun) > +this.now)
        .slice(0, 2)
        .map((item) => ({
          id: item.pgmCd,
          title: type === 'radio' ? item.displayNm : item.pgmOnm,
          isFirst: type !== 'radio' && item.firstClf === '01',
          broadTime: transLocaleTime(type, item.broadYmd, item.broadHm),
        }));
      data.push(...nextData);
      data = data.splice(0, 2);
    }

    const dataDetail = await Promise.all(
      data.map((item) => programDetail({ bis_program_code: item.id }).then((res) => ({ detail: res.data, ...item })))
    );

    return dataDetail.map((item, index) => ({
      id: item.id,
      title: item.title,
      link: item.detail.is_news_allow
        ? '/news'
        : type === 'radio'
        ? `/radio/${item.detail.program_id}`
        : `/tv/${item.detail.program_id}`,
      category: type !== 'radio' ? item.detail.category_Info.find((info) => info.local === mode).title : '',
      isFirst: item.isFirst,
      isLive: index === 0,
      broadTime: item.broadTime,
      timeLocale: type === 'world' ? 'GMT/UTC' : type === 'korea' ? 'Seoul' : type === 'un' ? 'NEW YORK' : 'KST',
    }));
  },
};
